const main = [
    { name: "🏠", href: "/" },
    { name: "Movies", href: "movies" },
    { name: "Dad Jokes", href: "dad-jokes" },
    { name: "Github Users", href: "github-users" },
  ];

export { main };